<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppLayout from '@/components/AppLayout.vue'

const authStore = useAuthStore()
const route = useRoute()

// Check if the current route should show the app layout
// Public pages like login and credential viewing should NOT show the layout
const showAppLayout = computed(() => {
  if (!authStore.isAuthenticated) return false
  if (route.meta.public) return false
  if (route.name === 'credential-view') return false
  return true
})
</script>

<template>
  <AppLayout v-if="showAppLayout">
    <RouterView />
  </AppLayout>
  <RouterView v-else />
</template>

